/* eslint-disable */
import React, { useState, useEffect } from "react";
import {
  Grid,
  TextField,
  Button,
  Typography,
  Card,
  CardContent,
  CardHeader,
  Box,
  Divider,
  CircularProgress,
  Alert,
  Paper
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import SaveIcon from "@material-ui/icons/Save";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import AccountBalanceWalletIcon from "@material-ui/icons/AccountBalanceWallet";
import HistoryIcon from "@material-ui/icons/History";
import LockIcon from "@material-ui/icons/Lock";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import moment from "moment";
import "moment/locale/th";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import { Label } from "reactstrap";
import TSSelect2 from "components/Forms/TSSelect2";
import { FinanceBudgetService } from "_services/financebudget.service";

moment.locale("th");

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(2)
  },
  card: {
    borderRadius: 8,
    boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
    overflow: "visible !important",
    position: "relative",
    zIndex: 20
  },
  balanceCard: {
    backgroundColor: "#eff6ff",
    border: "1px solid #bfdbfe",
    borderRadius: 8,
    padding: theme.spacing(2),
    marginBottom: theme.spacing(3)
  },
  balanceTitle: {
    color: "#1e40af",
    fontWeight: "bold",
    fontSize: "15px",
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(1)
  },
  balanceNumber: {
    fontSize: "18px",
    fontWeight: "bold"
  },
  sectionTitle: {
    fontSize: "15px",
    fontWeight: "bold",
    color: "#334155",
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1)
  },
  datetimeInputWrapper: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    zIndex: 20,
    "& .rdt": {
      width: "100%",
      position: "relative"
    },
    "& .rdtPicker": {
      position: "absolute",
      top: "calc(100% + 4px)",
      left: 0,
      zIndex: 99999,
      backgroundColor: "#ffffff",
      boxShadow: "0 10px 25px rgba(0,0,0,0.18)",
      borderRadius: "8px",
      border: "1px solid #cbd5e1",
      fontSize: "13px",
      fontFamily: '"Sarabun", "Tahoma", sans-serif',
      "& table": {
        margin: 0
      },
      "& table th, & table td": {
        fontSize: "13px",
        height: "26px",
        padding: "2px"
      },
      "& .rdtSwitch": {
        fontSize: "13px",
        fontWeight: "bold"
      }
    },
    "& input": {
      width: "100%",
      height: "38px",
      borderRadius: "4px",
      border: "1px solid #cbd5e1",
      padding: "8px 12px 8px 36px",
      fontSize: "14px",
      color: "#1e293b",
      backgroundColor: "#ffffff",
      cursor: "pointer",
      boxSizing: "border-box",
      fontFamily: '"Sarabun", "Tahoma", sans-serif',
      "&:hover": {
        borderColor: "#94a3b8"
      },
      "&:focus": {
        outline: "none",
        borderColor: "#2563eb",
        boxShadow: "0 0 0 2px rgba(37,99,235,0.1)"
      }
    }
  },
  datetimeIcon: {
    position: "absolute",
    left: "10px",
    color: "#64748b",
    zIndex: 1,
    pointerEvents: "none",
    fontSize: "1rem"
  }
}));

const FIXED_PROTECT_DEPS = [
  { value: "1", label: "ฝ่ายพัสดุและบำรุงรักษา" },
  { value: "2", label: "กลุ่มงานเภสัชกรรม" },
  { value: "3", label: "ฝ่ายการเงินและบัญชี" },
  { value: "4", label: "งานธุรการ" },
  { value: "5", label: "กลุ่มงานพยาธิวิทยา" }
];

const getCurrentFiscalYear = () => {
  const now = moment();
  return (now.month() >= 9 ? now.year() + 543 + 1 : now.year() + 543).toString();
};

export default function ProtectMoneyForm({ editId, onSaveSuccess, onCancel }) {
  const classes = useStyles();

  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  // User Profile & Department Role Check
  const [currentUser] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("currentUser") || "{}");
    } catch (e) {
      return {};
    }
  });

  const isFinanceAccount = (() => {
    const userDepts = Array.isArray(currentUser.userDepartment)
      ? currentUser.userDepartment
      : Array.isArray(currentUser.userView?.userDepartment)
      ? currentUser.userView.userDepartment
      : [];

    const isBudgetDep = userDepts.some(u => {
      const depKey = Number(u.departmentKey);
      return depKey === 102 || depKey === 135 || depKey === 157;
    });

    const isAdmin =
      currentUser?.roles?.includes("Admin") ||
      currentUser?.userName === "madarakung" ||
      userDepts.some(u => Number(u.departmentKey) === 108);

    return isBudgetDep || isAdmin;
  })();
  const isFinanceUser = isFinanceAccount;

  // Cascading options
  const [years, setYears] = useState([]);
  const [types, setTypes] = useState([]);
  const [budgets, setBudgets] = useState([]);
  const [outputs, setOutputs] = useState([]);
  const [activities, setActivities] = useState([]);
  const [projects, setProjects] = useState([]);

  // Independent options
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [sourceMoneys, setSourceMoneys] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [notes, setNotes] = useState([]);
  const [protectDeps, setProtectDeps] = useState(FIXED_PROTECT_DEPS);

  // Selected project balance data
  const [projectBalance, setProjectBalance] = useState(null);
  const [balanceLoading, setBalanceLoading] = useState(false);

  // Form State
  const [formData, setFormData] = useState({
    note: "",
    protectDep: "",
    number: "",
    kDate: moment().format("YYYY-MM-DD"),
    category: "",
    subCategory: "",
    method: "เฉพาะเจาะจง",
    byMoney: "",
    sourceMoney: "",
    year: getCurrentFiscalYear(),
    btid: "",
    budget: "",
    output: "",
    activity: "",
    project: "",
    money: "",
    company: ""
  });

  const [auditInfo, setAuditInfo] = useState({
    createdDT: null,
    createrCode: "",
    creatorName: "",
    lastEditDT: null,
    lastEditorCode: "",
    lastEditorName: "",
    checkerDT: null,
    checkerCode: "",
    checkerName: "",
    lastCheckerDT: null,
    lastCheckerCode: "",
    lastCheckerName: ""
  });

  const isChecked = Boolean(auditInfo.checkerDT || auditInfo.checkerCode);
  const isReadOnly = !isFinanceUser && isChecked;

  const formatThaiDateTime = dt => {
    if (!dt) return "-";
    return moment(dt).add(543, "years").format("DD/MM/YYYY HH:mm น.");
  };

  const methods = [
    "เฉพาะเจาะจง",
    "ตกลงราคา",
    "สอบราคา",
    "ประกวดราคาอิเล็กทรอนิกส์ (e-bidding)",
    "คัดเลือก",
    "จ้างเหมาบริการ",
    "อื่นๆ"
  ];
  const methodOptions = methods.map(m => ({ value: m, label: m }));

  useEffect(() => {
    initLoad();
  }, []);

  const initLoad = async () => {
    setLoading(true);
    try {
      const [yRes, catRes, compRes, noteRes, pDepRes] = await Promise.all([
        FinanceBudgetService.getYears(),
        FinanceBudgetService.getCategories(),
        FinanceBudgetService.getCompanies(),
        FinanceBudgetService.getNotes(),
        FinanceBudgetService.getProtectDeps()
      ]);

      if (yRes.data.success) {
        setYears(yRes.data.data);
      }
      if (catRes.data.success) setCategories(catRes.data.data);
      if (compRes.data.success) setCompanies(compRes.data.data);
      if (noteRes.data.success) setNotes(noteRes.data.data);
      if (pDepRes.data.success && pDepRes.data.data && pDepRes.data.data.length > 0) {
        setProtectDeps(pDepRes.data.data);
      }

      const defaultYear =
        formData.year || (yRes.data.data[0] ? yRes.data.data[0].value : "2570");
      await loadTypesForYear(defaultYear);

      if (editId) {
        await loadEditData(editId);
      } else {
        setAuditInfo({
          createdDT: null,
          createrCode: currentUser?.userName || "",
          creatorName: currentUser?.userView?.name || currentUser?.userName || "",
          lastEditDT: null,
          lastEditorCode: "",
          lastEditorName: "",
          checkerDT: null,
          checkerCode: "",
          checkerName: "",
          lastCheckerDT: null,
          lastCheckerCode: "",
          lastCheckerName: ""
        });
      }
    } catch (err) {
      console.error("Init form load error:", err);
    } finally {
      setLoading(false);
    }
  };

  const loadEditData = async id => {
    try {
      const res = await FinanceBudgetService.getProtectById(id);
      if (res.data.success) {
        const item = res.data.data;
        setAuditInfo({
          createdDT: item.createdDT,
          createrCode: item.createrCode,
          creatorName: item.creatorName,
          lastEditDT: item.lastEditDT,
          lastEditorCode: item.lastEditorCode,
          lastEditorName: item.lastEditorName,
          checkerDT: item.checkerDT,
          checkerCode: item.checkerCode,
          checkerName: item.checkerName,
          lastCheckerDT: item.lastCheckerDT,
          lastCheckerCode: item.lastCheckerCode,
          lastCheckerName: item.lastCheckerName
        });
        setFormData({
          note: item.note != null ? item.note.toString() : "",
          protectDep: item.protectDep != null ? item.protectDep.toString() : "",
          number: item.number || "",
          kDate: item.kDate
            ? moment(item.kDate).format("YYYY-MM-DD")
            : moment().format("YYYY-MM-DD"),
          category: item.category != null ? item.category.toString() : "",
          subCategory: item.subCategory != null ? item.subCategory.toString() : "",
          method: item.method || "เฉพาะเจาะจง",
          byMoney: item.byMoney || "",
          sourceMoney: item.sourceMoney != null ? item.sourceMoney.toString() : "",
          year: item.year != null ? item.year.toString() : "",
          btid: item.btid != null ? item.btid.toString() : "",
          budget: item.budget != null ? item.budget.toString() : "",
          output: item.output != null ? item.output.toString() : "",
          activity: item.activity != null ? item.activity.toString() : "",
          project: item.project != null ? item.project.toString() : "",
          money: item.money != null ? item.money.toString() : "",
          company: item.company != null ? item.company.toString() : ""
        });

        if (item.year) await loadTypesForYear(item.year);
        if (item.btid) {
          await loadBudgetsForType(item.year, item.btid);
          await loadSourceMoneysForType(item.btid);
        }
        if (item.budget) {
          await loadOutputsForBudget(item.year, item.btid, item.budget);
          if (item.output) {
            await loadActivitiesForOutput(
              item.year,
              item.btid,
              item.budget,
              item.output
            );
          } else {
            await loadActivitiesForBudget(
              item.year,
              item.btid,
              item.budget
            );
          }
        }
        if (item.activity)
          await loadProjectsForActivity(item.year, item.activity, item.btid);
        if (item.category) await loadSubCategoriesForCategory(item.category);
        if (item.project) await fetchProjectBalance(item.project);
      }
    } catch (err) {
      console.error("Load edit data error:", err);
    }
  };

  // =========================================================
  // Cascading Handlers
  // =========================================================

  const loadTypesForYear = async calYear => {
    try {
      const res = await FinanceBudgetService.getBudgetTypes(calYear);
      if (res.data.success) setTypes(res.data.data);
    } catch (err) {
      console.error(err);
    }
  };

  const loadBudgetsForType = async (calYear, btid) => {
    try {
      const res = await FinanceBudgetService.getBudgets(calYear, btid);
      if (res.data.success) setBudgets(res.data.data);
    } catch (err) {
      console.error(err);
    }
  };

  const loadOutputsForBudget = async (calYear, btid, budget) => {
    try {
      const res = await FinanceBudgetService.getOutputs(calYear, btid, budget);
      if (res.data.success) setOutputs(res.data.data);
    } catch (err) {
      console.error(err);
    }
  };

  const loadActivitiesForBudget = async (calYear, btid, budget) => {
    try {
      const res = await FinanceBudgetService.getActivities(
        calYear,
        btid,
        budget
      );
      if (res.data.success) setActivities(res.data.data);
    } catch (err) {
      console.error(err);
    }
  };

  const loadActivitiesForOutput = async (calYear, btid, budget, oid) => {
    try {
      const res = await FinanceBudgetService.getActivities(
        calYear,
        btid,
        budget,
        oid
      );
      if (res.data.success) setActivities(res.data.data);
    } catch (err) {
      console.error(err);
    }
  };

  const loadProjectsForActivity = async (calYear, aid, btid) => {
    try {
      const res = await FinanceBudgetService.getProjects(calYear, aid, btid);
      if (res.data.success) setProjects(res.data.data);
    } catch (err) {
      console.error(err);
    }
  };

  const loadSubCategoriesForCategory = async cid => {
    try {
      const res = await FinanceBudgetService.getSubCategories(
        cid ? parseInt(cid) : null
      );
      if (res.data.success) setSubCategories(res.data.data);
    } catch (err) {
      console.error(err);
    }
  };

  const loadSourceMoneysForType = async btid => {
    if (!btid) {
      setSourceMoneys([]);
      return;
    }
    try {
      const res = await FinanceBudgetService.getSourceMoneys(parseInt(btid, 10));
      if (res.data.success) {
        setSourceMoneys(res.data.data);
      }
    } catch (err) {
      console.error("Load source moneys error:", err);
    }
  };

  const handleNoteChange = val => {
    setFormData(prev => ({
      ...prev,
      note: val
    }));
  };

  const fetchProjectBalance = async pid => {
    if (!pid) {
      setProjectBalance(null);
      return;
    }
    setBalanceLoading(true);
    try {
      const res = await FinanceBudgetService.getProjectBalance(parseInt(pid));
      if (res.data.success) {
        setProjectBalance(res.data.data);
      }
    } catch (err) {
      console.error("Fetch balance error:", err);
    } finally {
      setBalanceLoading(false);
    }
  };

  // Change Handlers
  const handleYearChange = val => {
    setFormData(prev => ({
      ...prev,
      year: val,
      btid: "",
      sourceMoney: "",
      budget: "",
      output: "",
      activity: "",
      project: ""
    }));
    setSourceMoneys([]);
    setBudgets([]);
    setOutputs([]);
    setActivities([]);
    setProjects([]);
    setProjectBalance(null);
    if (val) loadTypesForYear(val);
  };

  const handleTypeChange = val => {
    setFormData(prev => ({
      ...prev,
      btid: val,
      sourceMoney: "",
      budget: "",
      output: "",
      activity: "",
      project: ""
    }));
    setSourceMoneys([]);
    setBudgets([]);
    setOutputs([]);
    setActivities([]);
    setProjects([]);
    setProjectBalance(null);
    if (val) {
      loadBudgetsForType(formData.year, val);
      loadSourceMoneysForType(val);
    }
  };

  const handleBudgetChange = val => {
    setFormData(prev => ({
      ...prev,
      budget: val,
      output: "",
      activity: "",
      project: ""
    }));
    setOutputs([]);
    setActivities([]);
    setProjects([]);
    setProjectBalance(null);
    if (val) {
      loadOutputsForBudget(formData.year, formData.btid, val);
      loadActivitiesForBudget(formData.year, formData.btid, val);
    }
  };

  const handleOutputChange = val => {
    setFormData(prev => ({
      ...prev,
      output: val,
      activity: "",
      project: ""
    }));
    setActivities([]);
    setProjects([]);
    setProjectBalance(null);
    if (val) {
      loadActivitiesForOutput(formData.year, formData.btid, formData.budget, val);
    } else if (formData.budget) {
      loadActivitiesForBudget(formData.year, formData.btid, formData.budget);
    }
  };

  const handleActivityChange = val => {
    setFormData(prev => ({
      ...prev,
      activity: val,
      project: ""
    }));
    setProjects([]);
    setProjectBalance(null);
    if (val) {
      loadProjectsForActivity(formData.year, val, formData.btid);
    }
  };

  const handleProjectChange = val => {
    setFormData(prev => ({ ...prev, project: val }));
    fetchProjectBalance(val);
  };

  const handleCategoryChange = val => {
    setFormData(prev => ({ ...prev, category: val, subCategory: "" }));
    setSubCategories([]);
    if (val) {
      loadSubCategoriesForCategory(val);
    }
  };

  const handleSubmit = async e => {
    e.preventDefault();

    if (isReadOnly) {
      alert("รายการนี้ได้รับการตรวจสอบแล้ว ผู้บันทึกไม่สามารถแก้ไขข้อมูลได้");
      return;
    }

    if (isFinanceUser) {
      if (!formData.year) {
        alert("กรุณาระบุปีงบประมาณ");
        return;
      }
      if (!formData.btid) {
        alert("กรุณาเลือกประเภทงบประมาณ");
        return;
      }
      if (!formData.project) {
        alert("กรุณาเลือกโครงการ");
        return;
      }
    }

    if (!formData.number) {
      alert("กรุณาระบุเลขที่ใบกันเงิน");
      return;
    }
    if (!formData.kDate) {
      alert("กรุณาระบุวันที่");
      return;
    }
    if (!formData.category) {
      alert("กรุณาเลือกหมวดจัดซื้อ");
      return;
    }
    if (!formData.money || parseFloat(formData.money) <= 0) {
      alert("กรุณาระบุจำนวนเงินที่ขออนุมัติกันเงิน");
      return;
    }

    const moneyVal = parseFloat(formData.money);
    if (
      isFinanceUser &&
      projectBalance &&
      moneyVal > projectBalance.remainMoney &&
      !editId
    ) {
      if (
        !window.confirm(
          `ยอดเงินที่ขออนุมัติ (${moneyVal.toLocaleString()} บาท) มากกว่ายอดคงเหลือโครงการ (${projectBalance.remainMoney.toLocaleString()} บาท) ต้องการบันทึกหรือไม่?`
        )
      ) {
        return;
      }
    }

    setSubmitting(true);
    try {
      const payload = {
        ...formData,
        year: formData.year || getCurrentFiscalYear(),
        money: moneyVal,
        note: formData.note ? parseInt(formData.note) : null,
        protectDep: formData.protectDep ? parseInt(formData.protectDep) : null,
        btid: formData.btid ? parseInt(formData.btid) : null,
        budget: formData.budget ? parseInt(formData.budget) : null,
        output: formData.output ? parseInt(formData.output) : null,
        activity: formData.activity ? parseInt(formData.activity) : null,
        project: formData.project ? parseInt(formData.project) : null,
        category: formData.category ? parseInt(formData.category) : null,
        subCategory: formData.subCategory ? parseInt(formData.subCategory) : null,
        sourceMoney: formData.sourceMoney ? parseInt(formData.sourceMoney) : null,
        company: formData.company ? parseInt(formData.company) : null,
        createrCode: currentUser?.userName || currentUser?.username,
        editorCode: currentUser?.userName || currentUser?.username,
        isFinanceUser: isFinanceUser
      };

      let res;
      if (editId) {
        res = await FinanceBudgetService.updateProtect(editId, payload);
      } else {
        res = await FinanceBudgetService.createProtect(payload);
      }

      if (res.data.success) {
        alert(res.data.message || "บันทึกข้อมูลเรียบร้อยแล้ว");
        if (onSaveSuccess) onSaveSuccess(res.data.data);
      }
    } catch (err) {
      alert(
        "เกิดข้อผิดพลาดในการบันทึก: " +
          (err.response?.data?.message || err.message)
      );
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) {
    return (
      <Box p={4} textAlign="center">
        <CircularProgress />
        <Typography style={{ marginTop: 16 }}>กำลังโหลดแบบฟอร์ม...</Typography>
      </Box>
    );
  }

  return (
    <Card className={classes.card}>
      <CardHeader
        title={
          editId ? "แก้ไขใบกันเงินงบประมาณ" : "บันทึกใบกันเงินงบประมาณ (ใหม่)"
        }
        subheader="กรอกรายละเอียดโครงการและจำนวนเงินที่ต้องการขออนุมัติกันเงิน"
        style={{ backgroundColor: "#1e3a8a", color: "#ffffff" }}
      />
      <CardContent style={{ padding: "24px" }}>
        <form onSubmit={handleSubmit}>
          {/* Status Alert Banners */}
          {isReadOnly && (
            <Box
              mb={3}
              p={2}
              style={{
                backgroundColor: "#fef2f2",
                border: "1px solid #fecaca",
                borderRadius: 8,
                color: "#991b1b",
                display: "flex",
                alignItems: "center"
              }}
            >
              <LockIcon style={{ marginRight: 12, fontSize: 28, color: "#dc2626" }} />
              <div>
                <Typography variant="body2" style={{ fontWeight: 600 }}>
                  รายการใบกันเงินนี้ได้รับการตรวจสอบโดยเจ้าหน้าที่การเงินแล้ว
                </Typography>
                <Typography variant="caption" style={{ color: "#7f1d1d" }}>
                  ผู้บันทึกข้อมูลไม่สามารถแก้ไขได้อีก (แสดงผลแบบดูข้อมูลเท่านั้น)
                </Typography>
              </div>
            </Box>
          )}
          {isFinanceUser && isChecked && (
            <Box
              mb={3}
              p={2}
              style={{
                backgroundColor: "#f0fdf4",
                border: "1px solid #bbf7d0",
                borderRadius: 8,
                color: "#166534",
                display: "flex",
                alignItems: "center"
              }}
            >
              <CheckCircleIcon style={{ marginRight: 12, fontSize: 28, color: "#16a34a" }} />
              <div>
                <Typography variant="body2" style={{ fontWeight: 600 }}>
                  รายการนี้ผ่านการตรวจสอบแล้ว (สิทธิ์เจ้าหน้าที่การเงิน: สามารถแก้ไข/ตรวจสอบเพิ่มเติมได้)
                </Typography>
              </div>
            </Box>
          )}

          {/* 1. ข้อมูลเอกสารและจัดซื้อจัดจ้าง */}
          <Typography className={classes.sectionTitle}>
            1. ข้อมูลเอกสารและจัดซื้อจัดจ้าง
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={3}>
              <TSSelect2
                zIndex={70}
                fontSize="14px"
                label="ตามบันทึก"
                options={notes}
                value={formData.note}
                onChange={e => handleNoteChange(e ? e.value : "")}
                isClearable={true}
                isDisabled={isReadOnly}
                placeholder="-- เลือกตามบันทึก --"
              />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <TSSelect2
                zIndex={69}
                fontSize="14px"
                label="หน่วยงานที่ขอ"
                options={protectDeps}
                value={formData.protectDep}
                onChange={e =>
                  setFormData({ ...formData, protectDep: e ? e.value : "" })
                }
                isClearable={true}
                isDisabled={isReadOnly}
                placeholder="-- เลือกหน่วยงาน --"
              />
            </Grid>

            <Grid item xs={12} sm={6} md={3} style={{ position: "relative", zIndex: 65 }}>
              <Label style={{ fontWeight: 500, fontSize: "14px", color: "#334155", marginBottom: 6, display: "inline-block" }}>
                เลขที่ใบกันเงิน *
              </Label>
              <TextField
                fullWidth
                size="small"
                variant="outlined"
                value={formData.number}
                onChange={e =>
                  setFormData({ ...formData, number: e.target.value })
                }
                required
                disabled={isReadOnly}
                placeholder="เช่น อก0206/บจ 001/70"
                InputProps={{
                  style: { height: 38, fontSize: "14px", backgroundColor: isReadOnly ? "#f1f5f9" : "#fff" }
                }}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={3} style={{ position: "relative", zIndex: 65 }}>
              <Label style={{ fontWeight: 500, fontSize: "14px", color: "#334155", marginBottom: 6, display: "inline-block" }}>
                ลงวันที่ *
              </Label>
              <div className={classes.datetimeInputWrapper}>
                <i className={`far fa-calendar-alt ${classes.datetimeIcon}`} />
                <Datetime
                  value={formData.kDate ? moment(formData.kDate) : null}
                  dateFormat="DD/MM/BBBB"
                  timeFormat={false}
                  closeOnSelect={true}
                  renderYear={(props, year) => <td {...props}>{year + 543}</td>}
                  inputProps={{
                    placeholder: "วว/ดด/ปปปป",
                    disabled: isReadOnly,
                    required: true,
                    style: { cursor: isReadOnly ? "not-allowed" : "pointer", backgroundColor: isReadOnly ? "#f1f5f9" : "#fff", height: 38 }
                  }}
                  onChange={m => {
                    if (moment.isMoment(m)) {
                      setFormData({ ...formData, kDate: m.format("YYYY-MM-DD") });
                    } else if (typeof m === "string") {
                      setFormData({ ...formData, kDate: m });
                    } else if (!m) {
                      setFormData({ ...formData, kDate: "" });
                    }
                  }}
                />
              </div>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <TSSelect2
                zIndex={60}
                fontSize="14px"
                label="หมวดจัดซื้อ *"
                options={categories}
                value={formData.category}
                onChange={e => handleCategoryChange(e ? e.value : "")}
                isClearable={true}
                isDisabled={isReadOnly}
                placeholder="-- เลือกหมวดจัดซื้อ --"
              />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <TSSelect2
                zIndex={59}
                fontSize="14px"
                label="หมวดย่อย"
                options={subCategories}
                value={formData.subCategory}
                onChange={e =>
                  setFormData({ ...formData, subCategory: e ? e.value : "" })
                }
                isClearable={true}
                isDisabled={isReadOnly}
                placeholder="-- เลือกหมวดย่อย --"
              />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <TSSelect2
                zIndex={58}
                fontSize="14px"
                label="วิธีจัดหา"
                options={methodOptions}
                value={formData.method}
                onChange={e =>
                  setFormData({ ...formData, method: e ? e.value : "" })
                }
                isClearable={false}
                isDisabled={isReadOnly}
                placeholder="-- เลือกวิธีจัดหา --"
              />
            </Grid>

            <Grid item xs={12} sm={6} md={6}>
              <TSSelect2
                zIndex={50}
                fontSize="14px"
                label="บริษัท / คู่ค้า"
                options={companies}
                value={formData.company}
                onChange={e =>
                  setFormData({ ...formData, company: e ? e.value : "" })
                }
                isClearable={true}
                isDisabled={isReadOnly}
                placeholder="-- เลือกบริษัท / คู่ค้า --"
              />
            </Grid>

            <Grid item xs={12} sm={6} md={6}>
              <Label style={{ fontWeight: 500, fontSize: "14px", color: "#334155", marginBottom: 6, display: "inline-block" }}>
                จำนวนเงินที่ขออนุมัติกันเงิน (บาท) *
              </Label>
              <TextField
                type="number"
                step="0.01"
                fullWidth
                size="small"
                variant="outlined"
                value={formData.money}
                onChange={e =>
                  setFormData({ ...formData, money: e.target.value })
                }
                required
                disabled={isReadOnly}
                InputProps={{
                  style: {
                    height: 38,
                    fontSize: "14px",
                    fontWeight: "bold",
                    color: "#1e3a8a",
                    backgroundColor: isReadOnly ? "#f1f5f9" : "#fff"
                  }
                }}
              />
            </Grid>
          </Grid>

          {/* 2. ข้อมูลงบประมาณและโครงการ (Hierarchical Dropdowns) - แสดงเฉพาะกลุ่มงานการเงินและบัญชี */}
          {isFinanceUser && (
            <React.Fragment>
              <Divider style={{ margin: "24px 0 16px 0" }} />
              <Typography className={classes.sectionTitle}>
                2. ข้อมูลงบประมาณและโครงการ (Hierarchical Dropdowns)
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={2}>
                  <TSSelect2
                    zIndex={40}
                    fontSize="14px"
                    label="ปีงบประมาณ *"
                    options={years}
                    value={formData.year}
                    onChange={e => handleYearChange(e ? e.value : "")}
                    isClearable={false}
                    isDisabled={isReadOnly}
                    placeholder="-- เลือกปี --"
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <TSSelect2
                    zIndex={39}
                    fontSize="14px"
                    label="ประเภทงบประมาณ *"
                    options={types}
                    value={formData.btid}
                    onChange={e => handleTypeChange(e ? e.value : "")}
                    isClearable={true}
                    isDisabled={isReadOnly}
                    placeholder="-- เลือกประเภทงบประมาณ --"
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <TSSelect2
                    zIndex={38}
                    fontSize="14px"
                    label="ข้อมูลงบประมาณ"
                    options={budgets}
                    value={formData.budget}
                    onChange={e => handleBudgetChange(e ? e.value : "")}
                    isClearable={true}
                    isDisabled={isReadOnly}
                    placeholder="-- เลือกงบประมาณ --"
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <TSSelect2
                    zIndex={57}
                    fontSize="14px"
                    label="แหล่งของเงิน"
                    options={sourceMoneys}
                    value={formData.sourceMoney}
                    onChange={e =>
                      setFormData({ ...formData, sourceMoney: e ? e.value : "" })
                    }
                    isClearable={true}
                    isDisabled={isReadOnly}
                    placeholder="-- เลือกแหล่งเงิน --"
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={6}>
                  <TSSelect2
                    zIndex={30}
                    fontSize="14px"
                    label="ข้อมูลกิจกรรม"
                    options={activities}
                    value={formData.activity}
                    onChange={e => handleActivityChange(e ? e.value : "")}
                    isClearable={true}
                    isDisabled={isReadOnly}
                    placeholder="-- เลือกกิจกรรม --"
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={6}>
                  <TSSelect2
                    zIndex={29}
                    fontSize="14px"
                    label="ข้อมูลโครงการ *"
                    options={projects}
                    value={formData.project}
                    onChange={e => handleProjectChange(e ? e.value : "")}
                    isClearable={true}
                    isDisabled={isReadOnly}
                    placeholder="-- เลือกโครงการ --"
                  />
                </Grid>
              </Grid>

              {/* Project Balance Widget (Live calculation) */}
              {balanceLoading ? (
                <Box my={2} textAlign="center">
                  <CircularProgress size={24} />
                  <Typography variant="caption" style={{ display: "block" }}>
                    กำลังคำนวณยอดเงินคงเหลือของโครงการ...
                  </Typography>
                </Box>
              ) : projectBalance ? (
                <div className={classes.balanceCard} style={{ marginTop: 16 }}>
                  <div className={classes.balanceTitle}>
                    <AccountBalanceWalletIcon style={{ marginRight: 8 }} />
                    สถานะการเงินโครงการ: {projectBalance.pname}
                  </div>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={3}>
                      <Typography variant="caption" color="textSecondary">
                        ยอดเงินจัดสรร
                      </Typography>
                      <div
                        className={classes.balanceNumber}
                        style={{ color: "#1e3a8a" }}
                      >
                        {projectBalance.allMoney.toLocaleString("th-TH", {
                          minimumFractionDigits: 2
                        })}{" "}
                        ฿
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                      <Typography variant="caption" color="textSecondary">
                        ยอดกันเงินสะสม
                      </Typography>
                      <div
                        className={classes.balanceNumber}
                        style={{ color: "#d97706" }}
                      >
                        {projectBalance.allReadyMoney.toLocaleString("th-TH", {
                          minimumFractionDigits: 2
                        })}{" "}
                        ฿
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                      <Typography variant="caption" color="textSecondary">
                        ยอดคืนกลับโครงการ
                      </Typography>
                      <div
                        className={classes.balanceNumber}
                        style={{ color: "#059669" }}
                      >
                        {projectBalance.sumRefund.toLocaleString("th-TH", {
                          minimumFractionDigits: 2
                        })}{" "}
                        ฿
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                      <Typography variant="caption" color="textSecondary">
                        ยอดเงินคงเหลือสุทธิ
                      </Typography>
                      <div
                        className={classes.balanceNumber}
                        style={{
                          color:
                            projectBalance.remainMoney > 0 ? "#16a34a" : "#dc2626"
                        }}
                      >
                        {projectBalance.remainMoney.toLocaleString("th-TH", {
                          minimumFractionDigits: 2
                        })}{" "}
                        ฿
                      </div>
                    </Grid>
                  </Grid>
                </div>
              ) : null}
            </React.Fragment>
          )}

          {/* Audit Log / History Information */}
          {(auditInfo.createdDT || auditInfo.lastEditDT || auditInfo.checkerDT || auditInfo.lastCheckerDT) && (
            <Paper
              variant="outlined"
              style={{
                marginTop: 24,
                padding: "16px 20px",
                backgroundColor: "#f8fafc",
                borderColor: "#cbd5e1",
                borderRadius: 8
              }}
            >
              <Typography
                variant="subtitle2"
                style={{
                  fontWeight: "bold",
                  color: "#334155",
                  marginBottom: 12,
                  display: "flex",
                  alignItems: "center"
                }}
              >
                <HistoryIcon style={{ marginRight: 6, fontSize: 18, color: "#64748b" }} />
                ประวัติการบันทึกและสถานะการตรวจสอบ
              </Typography>
              <Grid container spacing={2}>
                {auditInfo.createdDT && (
                  <Grid item xs={12} sm={6} md={3}>
                    <Typography variant="caption" style={{ color: "#64748b", display: "block" }}>
                      ผู้บันทึก
                    </Typography>
                    <Typography variant="body2" style={{ fontWeight: 600, color: "#1e293b" }}>
                      {auditInfo.creatorName || auditInfo.createrCode || "-"}
                    </Typography>
                    <Typography variant="caption" style={{ color: "#475569" }}>
                      {formatThaiDateTime(auditInfo.createdDT)}
                    </Typography>
                  </Grid>
                )}
                {auditInfo.lastEditDT && (
                  <Grid item xs={12} sm={6} md={3}>
                    <Typography variant="caption" style={{ color: "#64748b", display: "block" }}>
                      ผู้แก้ไขล่าสุด
                    </Typography>
                    <Typography variant="body2" style={{ fontWeight: 600, color: "#d97706" }}>
                      {auditInfo.lastEditorName || auditInfo.lastEditorCode || "-"}
                    </Typography>
                    <Typography variant="caption" style={{ color: "#475569" }}>
                      {formatThaiDateTime(auditInfo.lastEditDT)}
                    </Typography>
                  </Grid>
                )}
                {auditInfo.checkerDT && (
                  <Grid item xs={12} sm={6} md={3}>
                    <Typography variant="caption" style={{ color: "#64748b", display: "block" }}>
                      ผู้ตรวจสอบ
                    </Typography>
                    <Typography variant="body2" style={{ fontWeight: 600, color: "#16a34a" }}>
                      {auditInfo.checkerName || auditInfo.checkerCode || "-"}
                    </Typography>
                    <Typography variant="caption" style={{ color: "#475569" }}>
                      {formatThaiDateTime(auditInfo.checkerDT)}
                    </Typography>
                  </Grid>
                )}
                {auditInfo.lastCheckerDT && (
                  <Grid item xs={12} sm={6} md={3}>
                    <Typography variant="caption" style={{ color: "#64748b", display: "block" }}>
                      ผู้ตรวจสอบล่าสุด
                    </Typography>
                    <Typography variant="body2" style={{ fontWeight: 600, color: "#2563eb" }}>
                      {auditInfo.lastCheckerName || auditInfo.lastCheckerCode || "-"}
                    </Typography>
                    <Typography variant="caption" style={{ color: "#475569" }}>
                      {formatThaiDateTime(auditInfo.lastCheckerDT)}
                    </Typography>
                  </Grid>
                )}
              </Grid>
            </Paper>
          )}

          {/* Action Buttons */}
          <Box mt={4} display="flex" justifyContent="flex-end" gridGap={16}>
            {onCancel && (
              <Button
                variant="outlined"
                color="default"
                startIcon={<ArrowBackIcon />}
                onClick={onCancel}
                disabled={submitting}
                style={{ marginRight: 12 }}
              >
                ยกเลิก
              </Button>
            )}
            <Button
              type="submit"
              variant="contained"
              color="primary"
              startIcon={<SaveIcon />}
              disabled={submitting || isReadOnly}
              style={{
                minWidth: 160,
                backgroundColor: isReadOnly ? "#94a3b8" : isFinanceUser ? "#10b981" : undefined
              }}
            >
              {submitting
                ? "กำลังบันทึก..."
                : isReadOnly
                ? "ตรวจสอบแล้ว (ไม่อนุญาตให้แก้ไข)"
                : isFinanceUser
                ? (editId ? (isChecked ? "บันทึกการตรวจสอบอีกครั้ง" : "ตรวจสอบและบันทึกข้อมูล") : "บันทึกใบกันเงิน")
                : editId
                ? "บันทึกการแก้ไข"
                : "บันทึกใบกันเงิน"}
            </Button>
          </Box>
        </form>
      </CardContent>
    </Card>
  );
}
